// removed by extract-text-webpack-plugin
module.exports = {"loyalty-content":"app-pages-Customers-Loyalty-__Loyalty___2ZKWk","loyalty-container":"app-pages-Customers-Loyalty-__Loyalty___2HpKB","wrapper":"app-pages-Customers-Loyalty-__Loyalty___2VXIh","splash-content":"app-pages-Customers-Loyalty-__Loyalty___2DFTv"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Loyalty/Loyalty.css
// module id = 2082
// module chunks = 0